(function (scope) {
  "use strict";

  /**
   * @constructor
   * @param {sculpteo.PrintController} controller
   * @param {Viewer} viewer
   * @param {Design} design
   */
  var PrintSlicerView = (scope.PrintSlicerView = function (
    controller,
    design,
    viewerUI
  ) {
    this.controller = controller;
    this.design = design;
    this.viewerUI = viewerUI;
    this.viewer = viewerUI.viewer;

    this.slicerUI = null;

    this.$el = $("#slicer-settings");

    this.$el.on(
      "click",
      ".tool-back-default",
      this.backToDefaultView.bind(this)
    );
  });

  /**
   * Back to default view
   * @private
   */
  PrintSlicerView.prototype.backToDefaultView = function (e) {
    this.controller.switchTool(sculpteo.PrintToolsView.TOOLS.DASHBOARD);
  };

  /**
   * enable the part orientation
   * @public
   */
  PrintSlicerView.prototype.enabled = function () {
    this.$el.show();

    //hide the viewer 3D
    $("#viewer3d").hide();

    //show the slicer div
    $("#slicer").show();

    //get the print operation data for the orientation
    var op = this.viewerUI.design.print_operation.data;

    var w = 0;
    var h = 0;
    // ask for slices
    if (
      this.controller.views.viewer.currentViewerWidth >
      this.controller.views.viewer.currentViewerHeight
    ) {
      w = h = this.controller.views.viewer.currentViewerHeight - 70;
    } else {
      w = h = this.controller.views.viewer.currentViewerWidth - 70;
    }

    this.slicerUI = new SculpteoSlicerUI("slicer", w, h, $("#slicer-loader"));
    this.slicerUI.init(
      this.viewerUI.design.model_uuid,
      this.viewerUI.design.size.userScale,
      0.06
    ); // FIXME: layer_thickness
    this.slicerUI.refreshModel(
      [op.orientation_w, op.orientation_x, op.orientation_y, op.orientation_z],
      0,
      0,
      {}
    );
  };

  /**
   * disable the part orientation
   * @public
   */
  PrintSlicerView.prototype.disabled = function () {
    this.$el.hide();
    //hide the slicer view
    $("#slicer").hide();

    //delete the content of the slicer
    $("#slicer").empty();

    this.slicerUI = null;

    //show the viewer 3D
    $("#viewer3d").show();
  };
})((window.sculpteo = window.sculpteo || {}));
